import { getFirestore } from "firebase/firestore";
import { app } from "../firebase_init";

export const db = getFirestore(app);
